import { ScheduleDispatchTypes, VIEW_SCHEDULE_ENTRY } from "./types";
import { Dispatch } from 'redux';

export const selectScheduleEntry = (id: number) => async (dispatch: Dispatch<ScheduleDispatchTypes>) => {
  dispatch({type: VIEW_SCHEDULE_ENTRY, payload: id});
}